// A rate's charge as a reviewer reads it, for the rate-parsing screens (the converter's result and
// Review & publish). They showed the charge names only, or the raw formula with a field id in it,
// so the prices couldn't be checked before publishing. Kept free of the rest of the app (no
// imports) so it stays testable.

const num = s => String(parseFloat(s));

/**
 * @param {object} field      a rate field ({ title, type, values })
 * @param {object[]} fields   all the rate's fields, to name the charge a percentage refers to
 * @returns {string} e.g. "NZD 121.97/m³ or NZD 195.91/tonne, min NZD 115", "27% of TRANSPORT"
 */
export function rateChargeText(field, fields = []) {
    const v = field?.values?.flat || field?.values?.string || Object.values(field?.values || {})[0] || {};
    if (field?.type === 'string') return v.value || '';
    const cur = v.currency ? `${v.currency} ` : '';
    const formula = String(v.formula || '').trim();
    let m;
    if (formula) {
        // LCL weight or measure (metro trucking sheets, CBM tariffs): max(min, min, perCbm * cbm, perTon * tons)
        if ((m = formula.match(/^max\(\s*([\d.]+)\s*,\s*(?:[\d.]+\s*,\s*)?([\d.]+)\s*\*\s*cbm\s*,\s*([\d.]+)\s*\*\s*tons\s*\)$/))) {
            return `${cur}${num(m[2])}/m³ or ${cur}${num(m[3])}/tonne, min ${cur}${num(m[1])}`;
        }
        // Per kg with a minimum: max(min,x * perKg)
        if ((m = formula.match(/^max\(\s*([\d.]+)\s*,\s*x\s*\*\s*([\d.]+)\s*\)$/))) {
            return `${cur}${num(m[2])}/kg, min ${cur}${num(m[1])}`;
        }
        // A percentage of another charge: max(0, 27/100*((field_<id>)))
        if ((m = formula.match(/^max\(\s*0\s*,\s*([\d.]+)\s*\/\s*100\s*\*\s*\(\(\s*field_([\w]+)\s*\)\)\s*\)$/))) {
            const target = fields.find(f => String(f.id || '').replace(/-/g, '_') === m[2]);
            return `${num(m[1])}% of ${target?.title || 'another charge'}`;
        }
        return `=${formula}${v.currency ? ` ${v.currency}` : ''}`;
    }
    if (v.value === undefined || v.value === null || v.value === '') return '';
    return `${cur}${v.value}`;
}

/** The rate's charges as [{ title, text }], in the order the rate lists them. */
export function rateCharges(rate) {
    const fields = (rate?.offer?.sections || []).flatMap(s => s.offers?.[0]?.fields || []);
    return fields.map(f => ({ title: f.title, text: rateChargeText(f, fields) }));
}

/** "14 days · COASTAL SHIP + LINEHAUL TRUCK", from the rate's transit time and description. */
export function rateTransitText(rate) {
    const t = rate?.offer?.transitTime;
    const days = t === undefined || t === null || t === '' || Number(t) < 0 ? '' : `${t} day${Number(t) === 1 ? '' : 's'}`;
    return [days, rate?.offer?.description].filter(Boolean).join(' · ');
}
